<template>
    <div class="note-list-table">
        <b-table :fields="fields" :items="tableItems" responsive select-mode="single" selectable striped
            :tbody-tr-class="rowClass">
            <template v-slot:head()="data">
                {{ data.label.toUpperCase() }}
            </template>
            <template v-slot:cell(note)="data">
                <b-button v-if="data.item.hasPriority" class="btn-note-priority mr-3"
                    title="Priorisierung aufheben"
                    @click="unsetPriority(data.item.id)">
                    PRIO
                </b-button>
                <span class="break-lines">{{ data.value }}</span>
            </template>
            <template v-slot:cell(dates)="data">
                <table>
                    <tr>
                        <td class="noteDateLabel">
                            Hinzugefügt
                        </td>
                        <td class="noteDateValue">
                            {{ formatDateTime(data.value.dateSet) }}
                        </td>
                    </tr>
                    <tr v-if="data.value.dateReminder">
                        <td class="noteDateLabel topBorder dateReminder">
                            Wiedervorlage
                        </td>
                        <td class="noteDateValue topBorder dateReminder">
                            {{ formatDate(data.value.dateReminder) }}
                        </td>
                    </tr>
                    <tr v-if="data.value.dateDeadline">
                        <td class="noteDateLabel topBorder dateDeadLine">
                            Frist
                        </td>
                        <td class="noteDateValue topBorder dateDeadLine">
                            {{ formatDate(data.value.dateDeadline) }}
                        </td>
                    </tr>
                </table>
            </template>
        </b-table>
    </div>
</template>

<script>
    import {formatDate, formatDateTime} from '@js/functions/date';
    import Container from '@services/Container';

    const container = Container.getInstance();
    const recordRepository = container.getRecordRepository();
    const flashMessenger = container.getFlashMessenger();

    export default {
        props: {
            notes: {
                type: Object,
                required: true,
            },
        },
        emits: [
            'notes-updated',
        ],
        data() {
            return {
                fields: [
                    {
                        key: 'note',
                        label: 'Vermerk',
                    },
                    {
                        key: 'categoryName',
                        label: 'Thema',
                    },
                    {
                        key: 'userName',
                        label: 'von',
                    },
                    {
                        key: 'dates',
                        label: 'Datum',
                    },
                ],
            }
        },
        computed: {
            tableItems() {
                const tableItems = [];
                this.notes.data.forEach((item) => {
                    tableItems.push(
                        {
                            id: item.id,
                            ...item.attributes,
                        }
                    );
                });
                return tableItems;
            },
        },
        mounted() {
            this.recordId = this.$route.params.recordId
        },
        methods: {
            formatDate,
            formatDateTime,
            rowClass(item) {
                if (item?.hasPriority === true) {
                    return 'note-priority-border'
                }
            },
            unsetPriority(noteId) {
                recordRepository.unsetNotePriority(this.recordId, noteId).then(
                    () => {
                        flashMessenger.addSuccess('Priorierung des Vermerks wurde erfolgreich aufgehoben');
                        this.$emit('notes-updated');
                    },
                    () => {
                        flashMessenger.addError('Fehler beim Aufheben der Priorisierung des Vermerks');
                    }
                )
            },
        },
    }
</script>
